import React from 'react';
import { WashingMachineIcon, RefrigeratorIcon, TvIcon, MicrowaveIcon, InfoIcon, AlertCircleIcon, ClockIcon, CheckCircleIcon, XCircleIcon, PhoneIcon, MailIcon, MapPinIcon, UtensilsIcon } from 'lucide-react';
const ServiceCoverage = () => {
  return <div className="w-full" data-id="element-490">
      {/* Header Section */}
      <section className="relative py-20 bg-[#E57C23]" data-id="element-491">
        <div className="container mx-auto px-4" data-id="element-492">
          <div className="text-center" data-id="element-493">
            <h1 className="text-4xl font-bold text-white mb-4" data-id="element-494">
              Service Coverage
            </h1>
            <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-495">
              Comprehensive appliance repair services across the UK
            </p>
          </div>
        </div>
      </section>
      {/* Appliances We Cover */}
      <section className="py-16" data-id="element-496">
        <div className="container mx-auto px-4" data-id="element-497">
          <div className="text-center mb-12" data-id="element-498">
            <h2 className="text-3xl font-bold text-[#E57C23] mb-4" data-id="element-499">
              Appliances We Cover
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-500">
              Our expert engineers are trained to repair and maintain a wide
              range of household appliances
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6" data-id="element-501">
            <div className="bg-white p-6 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow duration-300" data-id="element-502">
              <div className="flex justify-center mb-4" data-id="element-503">
                <WashingMachineIcon className="w-12 h-12 text-[#F8B179]" data-id="element-504" />
              </div>
              <h3 className="font-bold text-[#E57C23]" data-id="element-505">Washing Machines</h3>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow duration-300" data-id="element-506">
              <div className="flex justify-center mb-4" data-id="element-507">
                <RefrigeratorIcon className="w-12 h-12 text-[#F8B179]" data-id="element-508" />
              </div>
              <h3 className="font-bold text-[#E57C23]" data-id="element-509">Refrigerators</h3>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow duration-300" data-id="element-510">
              <div className="flex justify-center mb-4" data-id="element-511">
                <TvIcon className="w-12 h-12 text-[#F8B179]" data-id="element-512" />
              </div>
              <h3 className="font-bold text-[#E57C23]" data-id="element-513">TVs & Set-Top Boxes</h3>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow duration-300" data-id="element-514">
              <div className="flex justify-center mb-4" data-id="element-515">
                <MicrowaveIcon className="w-12 h-12 text-[#F8B179]" data-id="element-516" />
              </div>
              <h3 className="font-bold text-[#E57C23]" data-id="element-517">Microwaves</h3>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow duration-300" data-id="element-518">
              <div className="flex justify-center mb-4" data-id="element-519">
                <div className="w-12 h-12 text-[#F8B179]" data-id="element-520" />
              </div>
              <h3 className="font-bold text-[#E57C23]" data-id="element-521">Ovens & Cookers</h3>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow duration-300" data-id="element-522">
              <div className="flex justify-center mb-4" data-id="element-523">
                <UtensilsIcon className="w-12 h-12 text-[#F8B179]" data-id="element-524" />
              </div>
              <h3 className="font-bold text-[#E57C23]" data-id="element-525">Dishwashers</h3>
            </div>
          </div>
        </div>
      </section>
      {/* Service Activation & Coverage Details */}
      <section className="py-16 bg-[#FFF8F0]" data-id="element-526">
        <div className="container mx-auto px-4" data-id="element-527">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-528">
            <div data-id="element-529">
              <h2 className="text-2xl font-bold text-[#E57C23] mb-6" data-id="element-530">
                Service Activation & Start Date
              </h2>
              <div className="space-y-6" data-id="element-531">
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-532">
                  <div className="flex items-start" data-id="element-533">
                    <div className="flex-shrink-0 mt-1" data-id="element-534">
                      <InfoIcon className="w-5 h-5 text-[#F8B179]" data-id="element-535" />
                    </div>
                    <div className="ml-4" data-id="element-536">
                      <h3 className="font-bold text-[#E57C23] mb-2" data-id="element-537">
                        When does my cover begin?
                      </h3>
                      <p className="text-gray-600" data-id="element-538">
                        Your protection starts immediately once your payment is
                        processed. You will receive a confirmation email shortly
                        afterwards.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-539">
                  <div className="flex items-start" data-id="element-540">
                    <div className="flex-shrink-0 mt-1" data-id="element-541">
                      <InfoIcon className="w-5 h-5 text-[#F8B179]" data-id="element-542" />
                    </div>
                    <div className="ml-4" data-id="element-543">
                      <h3 className="font-bold text-[#E57C23] mb-2" data-id="element-544">
                        Do I need to take any steps to activate my plan?
                      </h3>
                      <p className="text-gray-600" data-id="element-545">
                        No, activation happens automatically. Your plan begins
                        as soon as your purchase is complete and remains valid
                        for 12 months.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-546">
                  <div className="flex items-start" data-id="element-547">
                    <div className="flex-shrink-0 mt-1" data-id="element-548">
                      <InfoIcon className="w-5 h-5 text-[#F8B179]" data-id="element-549" />
                    </div>
                    <div className="ml-4" data-id="element-550">
                      <h3 className="font-bold text-[#E57C23] mb-2" data-id="element-551">
                        When does my coverage end?
                      </h3>
                      <p className="text-gray-600" data-id="element-552">
                        Your plan expires exactly 12 months later at 23:59 on
                        the final day, unless you renew it beforehand.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <h2 className="text-2xl font-bold text-[#E57C23] mt-12 mb-6" data-id="element-553">
                How Do I Request a Repair?
              </h2>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-554">
                <p className="text-gray-600 mb-4" data-id="element-555">Please contact us by:</p>
                <div className="flex items-center mb-3" data-id="element-556">
                  <PhoneIcon className="w-5 h-5 text-[#F8B179] mr-3" data-id="element-557" />
                  <span className="font-medium" data-id="element-558">0800 055 4969</span>
                </div>
                <div className="flex items-center" data-id="element-559">
                  <MailIcon className="w-5 h-5 text-[#F8B179] mr-3" data-id="element-560" />
                  <span className="font-medium" data-id="element-561">
                    bijayathakur8098@gmail.com
                  </span>
                </div>
                <p className="mt-4 text-gray-600" data-id="element-562">
                  Our team will organise your repair appointment, usually within
                  24 to 48 hours.
                </p>
              </div>
            </div>
            <div data-id="element-563">
              <h2 className="text-2xl font-bold text-[#E57C23] mb-6" data-id="element-564">
                What's Included?
              </h2>
              <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-id="element-565">
                <ul className="space-y-3" data-id="element-566">
                  <li className="flex items-start" data-id="element-567">
                    <CheckCircleIcon className="w-5 h-5 text-green-500 mt-1 mr-3 flex-shrink-0" data-id="element-568" />
                    <span data-id="element-569">
                      Unlimited repair visits and callouts for appliances
                      covered during your 12-month plan
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-570">
                    <CheckCircleIcon className="w-5 h-5 text-green-500 mt-1 mr-3 flex-shrink-0" data-id="element-571" />
                    <span data-id="element-572">All labour costs are covered</span>
                  </li>
                  <li className="flex items-start" data-id="element-573">
                    <CheckCircleIcon className="w-5 h-5 text-green-500 mt-1 mr-3 flex-shrink-0" data-id="element-574" />
                    <span data-id="element-575">Replacement parts provided when available</span>
                  </li>
                  <li className="flex items-start" data-id="element-576">
                    <CheckCircleIcon className="w-5 h-5 text-green-500 mt-1 mr-3 flex-shrink-0" data-id="element-577" />
                    <span data-id="element-578">
                      Engineer appointments are generally booked within 24–48
                      hours after reporting a fault
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-579">
                    <CheckCircleIcon className="w-5 h-5 text-green-500 mt-1 mr-3 flex-shrink-0" data-id="element-580" />
                    <span data-id="element-581">
                      Coverage includes mechanical and electrical faults
                    </span>
                  </li>
                </ul>
              </div>
              <h2 className="text-2xl font-bold text-[#E57C23] mb-6" data-id="element-582">
                What's Not Covered?
              </h2>
              <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-id="element-583">
                <ul className="space-y-3" data-id="element-584">
                  <li className="flex items-start" data-id="element-585">
                    <XCircleIcon className="w-5 h-5 text-red-500 mt-1 mr-3 flex-shrink-0" data-id="element-586" />
                    <span data-id="element-587">
                      Cosmetic damage or normal wear and tear of appliances
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-588">
                    <XCircleIcon className="w-5 h-5 text-red-500 mt-1 mr-3 flex-shrink-0" data-id="element-589" />
                    <span data-id="element-590">
                      Faults that existed prior to your plan start date
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-591">
                    <XCircleIcon className="w-5 h-5 text-red-500 mt-1 mr-3 flex-shrink-0" data-id="element-592" />
                    <span data-id="element-593">Damage caused by misuse or unauthorised repairs</span>
                  </li>
                  <li className="flex items-start" data-id="element-594">
                    <XCircleIcon className="w-5 h-5 text-red-500 mt-1 mr-3 flex-shrink-0" data-id="element-595" />
                    <span data-id="element-596">
                      Appliances older than 10 years at the start of your plan
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-597">
                    <XCircleIcon className="w-5 h-5 text-red-500 mt-1 mr-3 flex-shrink-0" data-id="element-598" />
                    <span data-id="element-599">
                      Damage due to floods, fires, or other natural disasters
                    </span>
                  </li>
                </ul>
              </div>
              <div className="space-y-6" data-id="element-600">
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-601">
                  <div className="flex items-start" data-id="element-602">
                    <div className="flex-shrink-0 mt-1" data-id="element-603">
                      <MapPinIcon className="w-5 h-5 text-[#F8B179]" data-id="element-604" />
                    </div>
                    <div className="ml-4" data-id="element-605">
                      <h3 className="font-bold text-[#E57C23] mb-2" data-id="element-606">
                        Service Area
                      </h3>
                      <p className="text-gray-600" data-id="element-607">
                        We currently provide services across mainland UK
                        postcodes only. For remote areas, response times may be
                        longer. Please contact us to confirm if your location is
                        covered.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-608">
                  <div className="flex items-start" data-id="element-609">
                    <div className="flex-shrink-0 mt-1" data-id="element-610">
                      <ClockIcon className="w-5 h-5 text-[#F8B179]" data-id="element-611" />
                    </div>
                    <div className="ml-4" data-id="element-612">
                      <h3 className="font-bold text-[#E57C23] mb-2" data-id="element-613">
                        Response Times
                      </h3>
                      <p className="text-gray-600" data-id="element-614">
                        We aim to schedule engineer visits within 24 to 48
                        hours, excluding weekends and public holidays.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-12" data-id="element-615">
            <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-[#F8B179]" data-id="element-616">
              <div className="flex items-start" data-id="element-617">
                <div className="flex-shrink-0 mt-1" data-id="element-618">
                  <AlertCircleIcon className="w-6 h-6 text-[#F8B179]" data-id="element-619" />
                </div>
                <div className="ml-4" data-id="element-620">
                  <h3 className="text-xl font-bold text-[#E57C23] mb-3" data-id="element-621">
                    Plan Exclusions & Prohibited Use
                  </h3>
                  <p className="text-gray-600 mb-4" data-id="element-622">
                    To ensure fair use and maintain service quality, the
                    following are excluded from cover:
                  </p>
                  <ul className="space-y-2 text-gray-600" data-id="element-623">
                    <li data-id="element-624">
                      • Damage or faults existing before your plan started
                    </li>
                    <li data-id="element-625">• Damage caused by neglect, misuse, or tampering</li>
                    <li data-id="element-626">• Repairs unrelated to normal appliance operation</li>
                    <li data-id="element-627">
                      • Any illegal or fraudulent use of our services or website
                    </li>
                    <li data-id="element-628">
                      • Appliances used contrary to manufacturer instructions
                    </li>
                  </ul>
                  <p className="mt-4 text-gray-600 font-medium" data-id="element-629">
                    Please note: If any of these exclusions apply, your plan may
                    be cancelled without refund or further support.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default ServiceCoverage;